"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _index = require("../../../helpers/index.js");

var _index2 = require("../../../utils/index.js");

var _utils = require("./utils");

var _excluded = ["toolName", "toolUsageID", "stepNumber", "toolUsageStepName", "toolType", "toolSelections", "outageID", "outageStatus"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var stringField = _index.formatters.stringField;
var stepNumberKeys = _utils.stepNumberKey.stepNumberKeys,
    getStepNumberKey = _utils.stepNumberKey.getStepNumberKey; // Keys that cannot be customized since they have a default value or works with a custom behavior

var lockedFields = ['toolUsageComplete'].concat(_toConsumableArray(stepNumberKeys));

var getToolCompleteTemplate = function getToolCompleteTemplate(_ref) {
  var toolName = _ref.toolName,
      toolUsageID = _ref.toolUsageID,
      stepNumber = _ref.stepNumber,
      toolUsageStepName = _ref.toolUsageStepName,
      toolType = _ref.toolType,
      toolSelections = _ref.toolSelections,
      outageID = _ref.outageID,
      outageStatus = _ref.outageStatus,
      rest = _objectWithoutProperties(_ref, _excluded);

  var cleanedRest = (0, _index2.removeLockedKeys)(rest, lockedFields);
  var stepNumberField = getStepNumberKey(stepNumber) || {};
  return {
    _telus: _objectSpread(_objectSpread({
      toolUsageComplete: 1,
      toolName: stringField(toolName),
      toolUsageID: toolUsageID,
      toolUsageStepName: stringField(toolUsageStepName),
      toolType: toolType,
      toolSelections: stringField(toolSelections),
      outageID: outageID,
      outageStatus: outageStatus
    }, stepNumberField), cleanedRest)
  };
};

var _default = getToolCompleteTemplate;
exports["default"] = _default;